module.exports = __webpack_public_path__ + "static/img/Group 22.08c26704.svg";